document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initMarquesina();
  initGaleriaProducto();
  initCantidad();
  initVariantesProducto();
  initResenasCarrusel();
  initFaqAccordion();
});

function initFaqAccordion() {
  document.querySelectorAll('[data-mt-faq-item]').forEach(function (item) {
    var toggle = item.querySelector('[data-mt-faq-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var abierta = item.classList.toggle('mt-activa');
      toggle.setAttribute('aria-expanded', abierta ? 'true' : 'false');
    });
  });
}

function initResenasCarrusel() {
  document.querySelectorAll('[data-mt-resenas-carrusel]').forEach(function (carrusel) {
    var track = carrusel.querySelector('[data-mt-resenas-track]');
    var prev = carrusel.querySelector('[data-mt-resenas-prev]');
    var next = carrusel.querySelector('[data-mt-resenas-next]');
    if (!track) return;
    var cards = Array.from(track.children);
    if (!cards.length) return;
    // The track contains the real reviews followed by an identical duplicate set,
    // so it can loop forever: once scroll drifts into (or before) the first copy,
    // we jump instantly by exactly one set-width to the matching spot in the other copy.
    var totalReal = cards.length / 2;

    function paso() {
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }

    function anchoSet() {
      return paso() * totalReal;
    }

    function normalizar() {
      var w = anchoSet();
      if (w <= 0) return;
      if (track.scrollLeft >= w) {
        track.scrollLeft -= w;
      } else if (track.scrollLeft < 0) {
        track.scrollLeft += w;
      }
    }

    function avanzar(n) {
      var p = paso();
      // going backward from the very start would hit the native scroll limit (0),
      // so first jump instantly to the equivalent spot in the duplicate set, then animate
      if (n < 0 && track.scrollLeft < p) {
        track.scrollLeft += anchoSet();
      }
      track.scrollBy({ left: n * p, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { avanzar(-1); });
    if (next) next.addEventListener('click', function () { avanzar(1); });

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(normalizar, 120);
    });
  });
}

function initGaleriaProducto() {
  var miniaturas = document.querySelectorAll('.mt-producto-miniatura');
  if (!miniaturas.length) return;
  var principal = document.querySelector('.mt-producto-imagen-principal img');
  if (!principal) return;
  miniaturas.forEach(function (btn) {
    btn.addEventListener('click', function () {
      principal.src = btn.dataset.mtImagenGrande;
      miniaturas.forEach(function (b) { b.classList.remove('mt-activa'); });
      btn.classList.add('mt-activa');
    });
  });
}

function initCantidad() {
  document.querySelectorAll('.mt-producto-form').forEach(function (form) {
    var input = form.querySelector('[data-mt-cantidad-input]');
    var menos = form.querySelector('[data-mt-cantidad-menos]');
    var mas = form.querySelector('[data-mt-cantidad-mas]');
    if (!input || !menos || !mas) return;
    menos.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    mas.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-mt-producto-opciones]').forEach(function (wrap) {
    var form = wrap.closest('form');
    if (!form) return;
    var variantesScript = form.querySelector('[data-mt-variantes]');
    if (!variantesScript) return;
    var variantes;
    try { variantes = JSON.parse(variantesScript.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var boton = form.querySelector('.mt-producto-comprar');
    var textoBoton = form.querySelector('[data-mt-texto-boton]');
    var compraCol = form.closest('.mt-producto-compra');
    var precioEl = compraCol ? compraCol.querySelector('.mt-precio-actual') : document.querySelector('.mt-precio-actual');

    var seleccion = {};
    wrap.querySelectorAll('.mt-opcion-valor.mt-seleccionada').forEach(function (b) {
      seleccion[b.dataset.mtOpcionIndex] = b.dataset.mtOpcionValor;
    });

    function actualizar() {
      var match = variantes.find(function (v) {
        return Object.keys(seleccion).every(function (idx) {
          return v.options[Number(idx)] === seleccion[idx];
        });
      });
      if (!match) return;
      idInput.value = match.id;
      if (precioEl) {
        precioEl.textContent = formatearPrecio(match.price, form.dataset.mtMoneyFormat);
      }
      if (boton) {
        var disponible = match.available;
        boton.disabled = !disponible;
        if (textoBoton) {
          textoBoton.textContent = disponible
            ? (boton.dataset.mtTextoDisponible || textoBoton.textContent)
            : (boton.dataset.mtTextoAgotado || 'Agotado');
        }
      }
    }

    wrap.querySelectorAll('.mt-opcion-valor').forEach(function (b) {
      b.addEventListener('click', function () {
        var grupo = b.closest('.mt-opcion-grupo');
        grupo.querySelectorAll('.mt-opcion-valor').forEach(function (x) { x.classList.remove('mt-seleccionada'); });
        b.classList.add('mt-seleccionada');
        seleccion[b.dataset.mtOpcionIndex] = b.dataset.mtOpcionValor;
        actualizar();
      });
    });
  });
}

function formatearPrecio(centavos, moneyFormat) {
  var monto = (centavos / 100).toFixed(2);
  if (!moneyFormat) return '$' + monto;
  return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, monto);
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.dataset.mtDelay || 0;
        setTimeout(function () {
          entry.target.classList.add('mt-visible');
        }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = Number(el.dataset.mtContador) || 0;
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(eased * target).toLocaleString('en-US');
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString('en-US');
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initMarquesina() {
  var wraps = document.querySelectorAll('.mt-marquesina-track');
  if (!wraps.length) return;
  wraps.forEach(function (track) {
    if (track.dataset.mtCloned) return;
    track.dataset.mtCloned = '1';
    var clone = track.innerHTML;
    track.insertAdjacentHTML('beforeend', clone);
  });
}
